import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryCertificateOverview } from "../../CommonComponents/CommonLibraryCertificateViews";
export const LibraryCertificatesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.certificates.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryCertificateOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
